import React, { useCallback, useRef, useState } from 'react';
import axios from '../../sagas/axios';
import Contents from '../../../contents/index';
import ModalAlert from '../../components/modal/modal_alert';
import ModalLoader from '../../../modal/modal_loader';
import moment from 'moment';
import compressImage from '../../../../lib/image_compressor';

const Edit = ({
  party,
  isApp,
  mainVisualUrlMedium,
  countriesPrefs,
  prefsCities,
}) => {
  const [placeGoogleMapUrl, setPlaceGoogleMapUrl] = useState(
    party.place_google_map_url || ''
  );
  const [prefId, setPrefId] = useState(party.pref_id || '');
  const [cityId, setCityId] = useState(party.city_id || '');
  const [title, setTitle] = useState(party.title || '');
  const [area, setArea] = useState(party.area || '');
  const [place, setPlace] = useState(party.place || '');
  const [partyDatetime, setPartyDatetime] = useState(
    moment(party.party_datetime).format('YYYY-MM-DDTHH:mm') || ''
  );
  const [partyEndDatetime, setPartyEndDatetime] = useState(
    moment(party.party_end_datetime).format('YYYY-MM-DDTHH:mm') || ''
  );
  const [receptionDatetime, setReceptionDatetime] = useState(
    moment(party.reception_datetime).format('YYYY-MM-DDTHH:mm') || ''
  );
  const [applicationDueDate, setApplicationDueDate] = useState(
    moment(party.application_due_date).format('YYYY-MM-DDTHH:mm') || ''
  );
  const [recruitStatus, setRecruitStatus] = useState(party.recruit_status || 0);
  const [malePrice, setMalePrice] = useState(party.male_price || '');
  const [maleRecruitStatus, setMaleRecruitStatus] = useState(
    party.male_recruit_status || 0
  );
  const [maleAgeFrom, setMaleAgeFrom] = useState(party.male_age_from || '');
  const [maleAgeTo, setMaleAgeTo] = useState(party.male_age_to || '');
  const [maleOtherCondition, setMaleOtherCondition] = useState(
    party.male_other_condition || ''
  );
  const [femalePrice, setFemalePrice] = useState(party.female_price || '');
  const [femaleRecruitStatus, setFemaleRecruitStatus] = useState(
    party.female_recruit_status || 0
  );
  const [femaleAgeFrom, setFemaleAgeFrom] = useState(
    party.female_age_from || ''
  );
  const [femaleAgeTo, setFemaleAgeTo] = useState(party.female_age_to || '');
  const [femaleOtherCondition, setFemaleOtherCondition] = useState(
    party.female_other_condition || ''
  );
  const [participantConditionTitle1, setParticipantConditionTitle1] = useState(
    party.participant_condition_title1 || ''
  );
  const [participantConditionBody1, setParticipantConditionBody1] = useState(
    party.participant_condition_body1 || ''
  );
  const [participantConditionTitle2, setParticipantConditionTitle2] = useState(
    party.participant_condition_title2 || ''
  );
  const [participantConditionBody2, setParticipantConditionBody2] = useState(
    party.participant_condition_body2 || ''
  );
  const [participantConditionTitle3, setParticipantConditionTitle3] = useState(
    party.participant_condition_title3 || ''
  );
  const [participantConditionBody3, setParticipantConditionBody3] = useState(
    party.participant_condition_body3 || ''
  );
  const [messageForParticipants, setMessageForParticipants] = useState(
    party.message_for_participants || ''
  );
  const [address, setAddress] = useState(party.address || '');
  const [maleCapacity, setMaleCapacity] = useState(party.male_capacity || 0);
  const [femaleCapacity, setFemaleCapacity] = useState(
    party.female_capacity || 0
  );
  const [isNextButtonDisplayed, setIsNextButtonDisplayed] = useState(true);
  const [image, setImage] = useState(mainVisualUrlMedium || '');
  const [selectedCityId, setSelectedCityId] = useState([]);
  const successRef = useRef(null);
  const errorRef = useRef(null);
  const loaderRef = useRef(null);

  const onChangeImageData = useCallback(
    async (imageFile) => {
      const compressedFile = await compressImage(imageFile);
      let formData = new FormData();
      formData.append('file', compressedFile);
      axios
        .patch(`/api/parties/${party.id}/upload_visual`, formData)
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.status === 200) {
            setImage(response.data.main_visual_url_medium);
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
    },
    [loaderRef, errorRef]
  );

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      loaderRef.current.openModal();
      const body = JSON.stringify({
        title: title,
        party_datetime: partyDatetime,
        party_end_datetime: partyEndDatetime,
        reception_datetime: receptionDatetime,
        application_due_date: applicationDueDate,
        recruit_status: recruitStatus,
        male_price: malePrice,
        male_recruit_status: maleRecruitStatus,
        male_age_from: maleAgeFrom,
        male_age_to: maleAgeTo,
        male_other_condition: maleOtherCondition,
        female_price: femalePrice,
        female_recruit_status: femaleRecruitStatus,
        female_age_from: femaleAgeFrom,
        female_age_to: femaleAgeTo,
        female_other_condition: femaleOtherCondition,
        participant_condition_title1: participantConditionTitle1,
        participant_condition_body1: participantConditionBody1,
        participant_condition_title2: participantConditionTitle2,
        participant_condition_body2: participantConditionBody2,
        participant_condition_title3: participantConditionTitle3,
        participant_condition_body3: participantConditionBody3,
        pref_id: prefId,
        city_id: cityId,
        area: area,
        place: place,
        address: address,
        place_google_map_url: placeGoogleMapUrl,
        message_for_participants: messageForParticipants,
        male_capacity: maleCapacity,
        female_capacity: femaleCapacity,
      });
      axios
        .post(`/api/parties/${party.id}/update`, body)
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.status === 200) {
            successRef.current.openModal();
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
    },
    [
      loaderRef,
      successRef,
      errorRef,
      party,
      title,
      partyDatetime,
      partyEndDatetime,
      receptionDatetime,
      applicationDueDate,
      recruitStatus,
      malePrice,
      maleRecruitStatus,
      maleAgeFrom,
      maleAgeTo,
      maleOtherCondition,
      malePrice,
      femaleRecruitStatus,
      femaleAgeFrom,
      femaleAgeTo,
      femaleOtherCondition,
      participantConditionTitle1,
      participantConditionBody1,
      participantConditionTitle2,
      participantConditionBody2,
      participantConditionTitle3,
      participantConditionBody3,
      prefId,
      cityId,
      area,
      place,
      address,
      placeGoogleMapUrl,
      messageForParticipants,
      maleCapacity,
      femaleCapacity,
    ]
  );

  const toPlacesPage = useCallback(() => {
    window && (window.location.href = `/parties/${party.id}`);
  });

  const countriesPrefSelect = countriesPrefs.map((countriesPref) => {
    return (
      <option value={countriesPref.id} key={countriesPref.id}>
        {countriesPref.name}
      </option>
    );
  });

  const prefsCitySelect = selectedCityId.map((prefsCity) => {
    return (
      <option value={prefsCity.city_id} key={prefsCity.city_id}>
        {prefsCity.city_name}
      </option>
    );
  });

  const changePrefId = (e) => {
    setPrefId(e.target.value);
    setCityId(0);
    setSelectedCityId(
      prefsCities.filter((prefsCity) => prefsCity.pref_id == e.target.value)
    );
  };

  const changeCityId = (e) => {
    setCityId(e.target.value);
  };

  return (
    <div>
      <main
        style={{ paddingBottom: isApp == false ? '165px' : '66px' }}
        className="bg-gray h-100 pt-3 min-vh-100"
      >
        <div className="container col-md-8 col-lg-6 p-3_5 d-flex justify-content-around">
          <label htmlFor="image">
            <a
              className={`card border-0 d-flex justify-content-center align-items-center hov--default p-3_5 d-block`}
            >
              {image ? (
                <img
                  src={image}
                  alt="image"
                  className="card-img-top card-img-top--list_eventreport mb-0 w-100"
                />
              ) : (
                <img
                  src="/assets2019/img/icon_camera.svg"
                  className="card-img-top card-img-top--list_eventreport mb-0 w-100"
                />
              )}
              <input
                type="file"
                accept="image/png, image/jpeg, image/heic, image/heif, .heic, .heif"
                onChange={(e) => {
                  onChangeImageData(e.target.files[0]);
                }}
                id="image"
                style={{ display: 'none' }}
              />
            </a>
          </label>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            タイトル
            <span className="message-required d-inline-block mb-2 ml-2">
              必須
            </span>
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
        </div>

        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            時刻
            <span className="message-required d-inline-block mb-2 ml-2">
              必須
            </span>
          </p>
        </div>
        <div className="shadow-sm mb-3 bg-white">
          <div className=" container col-md-8 col-lg-6 ">
            <label
              htmlFor="party-start-datetime-input-form"
              className="row justify-content-between p-3_5 border-bottom"
            >
              <p className="p-0 mb-0">開始</p>
              <input
                type="datetime-local"
                className="datetimepicker form-style-reset p-0 textarea--eventreport"
                id="party-start-datetime-input-form"
                defaultValue={moment(partyDatetime).format('YYYY-MM-DDTHH:mm')}
                onChange={(e) =>
                  setPartyDatetime(
                    moment(e.target.value).format('YYYY-MM-DDTHH:mm')
                  )
                }
                autoComplete="off"
              />
            </label>
            <label
              htmlFor="party-end-datetime-input-form"
              className="row justify-content-between p-3_5 border-bottom"
            >
              <p className="pr-2 mb-0">終了</p>
              <input
                type="datetime-local"
                className="datetimepicker form-style-reset p-0 textarea--eventreport"
                id="party-end-datetime-input-form"
                defaultValue={moment(partyEndDatetime).format(
                  'YYYY-MM-DDTHH:mm'
                )}
                onChange={(e) =>
                  setPartyEndDatetime(
                    moment(e.target.value).format('YYYY-MM-DDTHH:mm')
                  )
                }
                autoComplete="off"
              />
            </label>
            <label
              htmlFor="party-meeting_datetime"
              className="row justify-content-between p-3_5 border-bottom"
            >
              <p className="pr-2 mb-0">集合</p>
              <input
                type="datetime-local"
                id="party-meeting_datetime"
                className="datetimepicker form-style-reset p-0 textarea--eventreport"
                defaultValue={moment(receptionDatetime).format(
                  'YYYY-MM-DDTHH:mm'
                )}
                onChange={(e) =>
                  setReceptionDatetime(
                    moment(e.target.value).format('YYYY-MM-DDTHH:mm')
                  )
                }
                autoComplete="off"
              />
            </label>
            <label
              htmlFor="party-application_due_date"
              className="row justify-content-between p-3_5"
            >
              <p className="pr-2 mb-0">申込締切</p>
              <input
                type="datetime-local"
                id="party-application_due_date"
                className="datetimepicker form-style-reset p-0 textarea--eventreport"
                defaultValue={moment(applicationDueDate).format(
                  'YYYY-MM-DDTHH:mm'
                )}
                onChange={(e) =>
                  setApplicationDueDate(
                    moment(e.target.value).format('YYYY-MM-DDTHH:mm')
                  )
                }
                autoComplete="off"
              />
            </label>
          </div>
        </div>

        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            都道府県
            <span className="message-required d-inline-block mb-2 ml-2">
              必須
            </span>
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <select
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
              value={prefId}
              onChange={changePrefId}
            >
              <option value={0} key={0}>
                選択してください
              </option>
              {countriesPrefSelect}
            </select>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            市区町村
            <span className="message-required d-inline-block mb-2 ml-2">
              必須
            </span>
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <select
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
              value={cityId}
              onChange={changeCityId}
            >
              <option value={0} key={0}>
                選択してください
              </option>
              {prefsCitySelect}
            </select>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            丁目番地等
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            開催場所名称
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={place}
              onChange={(e) => setPlace(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            開催エリア（「銀座」等）
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={area}
              onChange={(e) => setArea(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            GoogleマップURL
            <span className="message-required d-inline-block mb-2 ml-2">
              必須
            </span>
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={placeGoogleMapUrl}
              onChange={(e) => setPlaceGoogleMapUrl(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            募集状況
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <select
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
              value={recruitStatus}
              onChange={(e) => setRecruitStatus(e.target.value)}
            >
              <option value={0} key={0}>
                下書き中
              </option>
              <option value={1} key={1}>
                募集中
              </option>
              <option value={2} key={2}>
                募集終了
              </option>
              <option value={3} key={3}>
                開催中止
              </option>
            </select>
          </div>
        </div>

        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            男性の参加料金
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="number"
              className="p-0 w-100 textarea--eventreport"
              value={malePrice}
              onChange={(e) => setMalePrice(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            男性の参加可能人数
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="number"
              className="p-0 w-100 textarea--eventreport"
              value={maleCapacity}
              onChange={(e) => setMaleCapacity(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            男性の年齢制限
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <div className="row">
              <div className="col-4">
                <input
                  type="number"
                  className="p-0 w-100 textarea--eventreport"
                  value={maleAgeFrom}
                  onChange={(e) => setMaleAgeFrom(e.target.value)}
                />
              </div>
              〜
              <div className="col-4">
                <input
                  type="number"
                  className="p-0 w-100 textarea--eventreport"
                  value={maleAgeTo}
                  onChange={(e) => setMaleAgeTo(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            男性の募集状況
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <select
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
              value={maleRecruitStatus}
              onChange={(e) => setMaleRecruitStatus(e.target.value)}
            >
              <option value={0} key={0}>
                募集中
              </option>
              <option value={1} key={1}>
                募集終了
              </option>
              <option value={2} key={2}>
                急募
              </option>
              <option value={3} key={3}>
                残りわずか
              </option>
              <option value={3} key={3}>
                調整中
              </option>
            </select>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            男性のその他条件
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={maleOtherCondition}
              onChange={(e) => setMaleOtherCondition(e.target.value)}
            />
          </div>
        </div>

        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            女性の参加料金
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="number"
              className="p-0 w-100 textarea--eventreport"
              value={femalePrice}
              onChange={(e) => setFemalePrice(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            女性の参加可能人数
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="number"
              className="p-0 w-100 textarea--eventreport"
              value={femaleCapacity}
              onChange={(e) => setFemaleCapacity(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            女性の年齢制限
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <div className="row">
              <div className="col-4">
                <input
                  type="number"
                  className="p-0 w-100 textarea--eventreport"
                  value={femaleAgeFrom}
                  onChange={(e) => setFemaleAgeFrom(e.target.value)}
                />
              </div>
              〜
              <div className="col-4">
                <input
                  type="number"
                  className="p-0 w-100 textarea--eventreport"
                  value={femaleAgeTo}
                  onChange={(e) => setFemaleAgeTo(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            女性の募集状況
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <select
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
              value={femaleRecruitStatus}
              onChange={(e) => setFemaleRecruitStatus(e.target.value)}
            >
              <option value={0} key={0}>
                募集中
              </option>
              <option value={1} key={1}>
                募集終了
              </option>
              <option value={2} key={2}>
                急募
              </option>
              <option value={3} key={3}>
                残りわずか
              </option>
              <option value={3} key={3}>
                調整中
              </option>
            </select>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            女性のその他条件
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={femaleOtherCondition}
              onChange={(e) => setFemaleOtherCondition(e.target.value)}
            />
          </div>
        </div>

        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            参加条件のタイトル1
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={participantConditionTitle1}
              onChange={(e) => setParticipantConditionTitle1(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            参加条件の本文1
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <textarea
              className="p-0 w-100 textarea--eventreport"
              value={participantConditionBody1}
              onChange={(e) => setParticipantConditionBody1(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            参加条件のタイトル2
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={participantConditionTitle2}
              onChange={(e) => setParticipantConditionTitle2(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            参加条件の本文2
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <textarea
              className="p-0 w-100 textarea--eventreport"
              value={participantConditionBody2}
              onChange={(e) => setParticipantConditionBody2(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            参加条件のタイトル3
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={participantConditionTitle3}
              onChange={(e) => setParticipantConditionTitle3(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            参加条件の本文3
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <textarea
              className="p-0 w-100 textarea--eventreport"
              value={participantConditionBody3}
              onChange={(e) => setParticipantConditionBody3(e.target.value)}
            />
          </div>
        </div>

        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            会場での集合方法
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <textarea
              className="p-0 w-100 textarea--eventreport"
              value={messageForParticipants}
              onChange={(e) => setMessageForParticipants(e.target.value)}
            />
          </div>
        </div>

        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            本文
          </p>
        </div>
        <Contents
          foreignKeyId={party.id}
          isApp={isApp}
          model={'Party'}
          isCoursesDisplayed={true}
          displayNextButtonFunc={() => setIsNextButtonDisplayed(true)}
          hideNextButtonFunc={() => setIsNextButtonDisplayed(false)}
        />
      </main>
      {isNextButtonDisplayed && (
        <div className="fixed-bottom">
          <div className="container col-md-8 col-lg-6 d-flex justify-content-around">
            <div
              className="container d-flex justify-content-around"
              style={{ marginBottom: isApp ? '24px' : '' }}
            >
              <button
                type="button"
                className={`col-6 a-button a-button__top a-button--orange mr-2 w-100 ${
                  isApp == false ? 'mb-2' : ''
                }`}
                onClick={(e) => onSubmit(e)}
              >
                作成/更新する
              </button>
            </div>
          </div>
        </div>
      )}
      <ModalAlert
        ref={successRef}
        name="コース作成完了"
        content="コース作成/更新に成功しました。"
        approveFunc={toPlacesPage}
      />
      <ModalAlert
        ref={errorRef}
        name="コース作成失敗"
        content="コース作成に失敗しました。時間をおいてもう一度お試しください。"
      />
      <ModalLoader ref={loaderRef} />
    </div>
  );
};

export default Edit;
